/* ================================================================
   DROP DEAD — Course sales hero (progressive enhancement)
   - Smooth-scroll the primary CTA to the buy card (any element with
     id starting with "MainProduct-", which main-product.liquid
     guarantees is rendered on every product page).
   - Open a <dialog> with a lazy-mounted Vimeo iframe for the
     trailer modal. Iframe is only injected on first open so the
     hero renders zero third-party requests by default.
   ================================================================ */

(function () {
  'use strict';

  function headerOffset() {
    var val = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var px = parseInt(val, 10);
    if (isFinite(px) && px > 0) return px + 16;
    return 16;
  }

  function findBuyCard() {
    var anchored = document.querySelector('[id^="MainProduct-"]');
    if (anchored) return anchored;
    return document.getElementById('MainProduct') || null;
  }

  function smoothScrollTo(target) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function vimeoEmbedSrc(rawUrl) {
    if (!rawUrl) return '';
    try {
      var u = new URL(rawUrl, window.location.origin);
      var idMatch = u.pathname.match(/(\d+)/);
      if (!idMatch) return '';
      return 'https://player.vimeo.com/video/' + idMatch[1] + '?autoplay=1&title=0&byline=0&portrait=0&dnt=1';
    } catch (e) {
      var fallback = String(rawUrl).match(/(\d{6,})/);
      return fallback ? 'https://player.vimeo.com/video/' + fallback[1] + '?autoplay=1&title=0&byline=0&portrait=0&dnt=1' : '';
    }
  }

  function initHero(root) {
    if (!root || root.dataset.ddCourseHeroInit === '1') return;
    root.dataset.ddCourseHeroInit = '1';

    if (root.querySelector('.dd-course-hero__bg img')) {
      root.setAttribute('data-has-bg', 'true');
    }

    /* Class-based hooks: see the comment in dd-course-hero.liquid for
       why this isn't `[data-dd-course-hero-enroll]` /
       `[data-dd-course-hero-trailer]` anymore. tl;dr: dd-button's
       inline-hash `data_attrs` parameter silently drops in some
       Shopify render contexts, leaving the buttons inert. The BEM
       modifier classes were already on the elements for styling, so
       repurposing them as JS hooks is zero-overhead. */
    var enrollLinks = root.querySelectorAll('.dd-course-hero__cta--primary');
    enrollLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        /* Course members get the "Access course" variant of the
           primary CTA, marked with .dd-course-hero__cta--access.
           That link's href points at product.metafields.custom.lms_url
           (Syndicate course URL) — it must NOT be hijacked into a
           same-page scroll. Bail out early and let the browser
           follow the native href (works for any URL, modifier-keyed
           clicks, middle-click, right-click "Open in new tab", etc). */
        if (link.classList.contains('dd-course-hero__cta--access')) return;
        var target = findBuyCard();
        if (!target) return;
        event.preventDefault();
        smoothScrollTo(target);
        if (history && history.replaceState) {
          history.replaceState(null, '', '#' + target.id);
        }
      });
    });

    var trailerButton = root.querySelector('.dd-course-hero__cta--secondary');
    var dialog = root.querySelector('[data-dd-course-hero-dialog]');
    var closeButton = root.querySelector('[data-dd-course-hero-close]');
    var frame = root.querySelector('[data-dd-course-hero-frame]');
    /* Trailer URL lives on the section root (`data-trailer-url`),
       set by dd-course-hero.liquid. Reading it here keeps the button
       markup pure and means we don't need a per-button data-attribute
       to survive the dd-button render. */
    var trailerUrl = root.getAttribute('data-trailer-url') || '';

    if (!trailerButton || !dialog || !frame) return;

    function openDialog() {
      var src = vimeoEmbedSrc(trailerUrl);
      if (!src) return;
      if (!frame.querySelector('iframe')) {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', 'Course trailer');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        frame.appendChild(iframe);
      }
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      var iframe = frame.querySelector('iframe');
      if (iframe) {
        frame.removeChild(iframe);
      }
    }

    trailerButton.addEventListener('click', function (event) {
      event.preventDefault();
      openDialog();
    });

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        closeDialog();
      });
    }

    dialog.addEventListener('cancel', function () {
      var iframe = frame.querySelector('iframe');
      if (iframe) frame.removeChild(iframe);
    });

    dialog.addEventListener('close', function () {
      var iframe = frame.querySelector('iframe');
      if (iframe) frame.removeChild(iframe);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        closeDialog();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-dd-course-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-dd-course-hero]') : null;
    if (root) initHero(root);
  });
})();
